import { render, staticRenderFns } from "./manutencaoAvancada.vue?vue&type=template&id=0a709a61&"
import script from "./manutencaoAvancada.vue?vue&type=script&lang=js&"
export * from "./manutencaoAvancada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports